import { ThemeConfig } from './theme';

export type FontFamilyConfig = {
  primary: string;
  secondary: string;
  fallback: string;
};

export type FontFamily = keyof FontFamilyConfig;

export const resolveFontFamily =
  (theme: ThemeConfig) =>
  (fontFamily: FontFamily): string =>
    theme.fontFamilies[fontFamily];
